import React, { useEffect, useRef } from "react";
import mermaid from "mermaid";

let mermaidInitialized = false;

function initMermaid() {
  if (mermaidInitialized) return;
  mermaid.initialize({
    startOnLoad: false,
    theme: "neutral",
  });
  mermaidInitialized = true;
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

const MermaidBlock = ({ chart }) => {
  const containerRef = useRef(null);
  const renderIdRef = useRef(
    `mmd-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
  );

  useEffect(() => {
    const container = containerRef.current;
    const definition = chart?.trim();
    if (!container || !definition) return undefined;

    let cancelled = false;
    initMermaid();
    const renderId = `${renderIdRef.current}-${Math.random().toString(36).slice(2, 7)}`;

    mermaid
      .render(renderId, definition)
      .then(({ svg, bindFunctions }) => {
        if (cancelled || !container) return;
        container.innerHTML = svg;
        bindFunctions?.(container);
      })
      .catch((err) => {
        if (cancelled || !container) return;
        const msg = err?.message || String(err);
        container.innerHTML = `<pre class="services-mermaid-error">${escapeHtml(msg)}</pre>`;
      });

    return () => {
      cancelled = true;
    };
  }, [chart]);

  return (
    <div
      className="services-mermaid"
      ref={containerRef}
      role="img"
      aria-label="Mermaid diagram"
    />
  );
};

export default MermaidBlock;
